export default "__VITE_ASSET__cb5fc815__"